(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50,
            'itemsPerPageSmall': 20,
            'itemsPerPageOptions': [
                {label: "20", value: 20},
                {label: "50", value: 50},
                {label: "100", value: 100}
            ],
            'sortOptions': {
                "pt-br": [
                    {id: 1, label: "Recém atualizados", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Maior preço", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Menor preço", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Lançamento", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas peças", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Maior desconto", value: "metadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Mais vendidos", value: "metadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Sem estoque", value: "metadata.inventory", direction: 'asc'}
                ],
                "es": [
                    {id: 1, label: "Recién actualizado", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Precio más alto", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Precio más bajo", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas piezas", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Mayor descuento", value: "metadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Más vendidos", value: "metadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Agotado", value: "metadata.inventory", direction: 'asc'}
                ],
                "en": [
                    {id: 1, label: "Just updated", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Highest price", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Lowest price", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Published", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Latest pieces", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Biggest discount", value: "metadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Best Sellers", value: "metadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Out of stock", value: "metadata.inventory", direction: 'asc'}
                ]
            },
            'groupByColorSortOptions': {
                "pt-br": [
                    {id: 1, label: "Recém atualizados", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "colorGroupMetadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "colorGroupMetadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Maior preço", value: "colorGroupMetadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Menor preço", value: "colorGroupMetadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Lançamento", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas peças", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Maior desconto", value: "colorGroupMetadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Mais vendidos", value: "colorGroupMetadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Sem estoque", value: "colorGroupMetadata.inventory", direction: 'asc'}
                ],
                "es": [
                    {id: 1, label: "Recién actualizado", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "colorGroupMetadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "colorGroupMetadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Precio más alto", value: "colorGroupMetadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Precio más bajo", value: "colorGroupMetadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas piezas", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Mayor descuento", value: "colorGroupMetadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Más vendidos", value: "colorGroupMetadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Agotado", value: "metadata.inventory", direction: 'asc'}
                ],
                "en": [
                    {id: 1, label: "Just updated", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "colorGroupMetadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "colorGroupMetadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Highest price", value: "colorGroupMetadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Lowest price", value: "colorGroupMetadata.minValue", direction: 'asc'},
                    {id: 6, label: "Published", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Latest pieces", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Biggest discount", value: "colorGroupMetadata.maxDiscount", direction: 'desc'},
                    {id: 10, label: "Best Sellers", value: "colorGroupMetadata.soldQuantity", direction: 'desc'},
                    {id: 11, label: "Out of stock", value: "colorGroupMetadata.inventory", direction: 'asc'}
                ]
            },
            'immoSortOptions': {
                "pt-br": [
                    {id: 1, label: "Recém atualizados", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Maior preço", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Menor preço", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Lançamento", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Em construção", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Entregue", value: "isDelivered", direction: 'desc'}
                ],
                "es": [
                    {id: 1, label: "Recién actualizado", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Precio más alto", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Precio más bajo", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Publicados", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Lanzamiento", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "En construcción", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Entregado", value: "isDelivered", direction: 'desc'}
                ],
                "en": [
                    {id: 1, label: "Just updated", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Highest price", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Lowest price", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Published", value: "metadata.published", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Under construction", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Delivered", value: "isDelivered", direction: 'desc'}
                ]
            },
            'hubSortOptions': {
                "pt-br": [
                    {id: 1, label: "Recém atualizados", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Maior preço", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Menor preço", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Lançamento", value: "isLaunch", direction: 'desc'},
                    {id: 7, label: "Últimas peças", value: "isBasic", direction: 'desc'},
                    {id: 8, label: "Maior desconto", value: "metadata.maxDiscount", direction: 'desc'}
                ],
                "es": [
                    {id: 1, label: "Recién actualizado", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Precio más alto", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Precio más bajo", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 7, label: "Últimas piezas", value: "isBasic", direction: 'desc'},
                    {id: 8, label: "Mayor descuento", value: "metadata.maxDiscount", direction: 'desc'}
                ],
                "en": [
                    {id: 1, label: "Just updated", value: "lastModifiedDate", direction: 'desc'},
                    {id: 2, label: "A-Z", value: "metadata.simplifiedName", direction: 'asc'},
                    {id: 3, label: "Z-A", value: "metadata.simplifiedName", direction: 'desc'},
                    {id: 4, label: "Highest price", value: "metadata.maxValue", direction: 'desc'},
                    {id: 5, label: "Lowest price", value: "metadata.minValue", direction: 'asc'},
                    {id: 6, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 7, label: "Latest pieces", value: "isBasic", direction: 'desc'},
                    {id: 8, label: "Biggest discount", value: "metadata.maxDiscount", direction: 'desc'}
                ]
            },
            'importHubSortOptions': {
                "pt-br": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'}
                ],
                "es": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'},
                ],
                "en": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'},
                ]
            },

            'defaultSortOption': 5
        });
})();
